import APIService from '../base'
import type { AxiosResponse } from 'axios'
import type {
  CategoryListRequest,
  CategoryQuery,
  CategoryResponse,
} from '@/types/category'
import type { CommonPagination } from '@/types/common'

export class CategoryService {
  static getList(
    query?: CategoryQuery,
  ): Promise<AxiosResponse<CommonPagination<CategoryResponse>>> {
    return APIService.get('/v1/product-categories', { params: query })
  }

  static syncCategory(body: CategoryListRequest): Promise<AxiosResponse<void>> {
    return APIService.post('/v1/product-categories/sync', body)
  }
}
